import { render, staticRenderFns } from "./gclick-processo-select.vue?vue&type=template&id=757feb5c&"
import script from "./gclick-processo-select.vue?vue&type=script&lang=js&"
export * from "./gclick-processo-select.vue?vue&type=script&lang=js&"
import style0 from "./gclick-processo-select.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports